import React, { createContext, useContext, useState } from 'react';
import { Reviewer } from '../types';

interface ReviewerContextType {
    currentReviewer: Reviewer[] | null;
    setCurrentReviewer: (reviewer: Reviewer[] | null) => void;
}

const ReviewerContext = createContext<ReviewerContextType | undefined>(undefined);

export function ReviewerProvider({ children }: { children: React.ReactNode }) {
    const [currentReviewer, setCurrentReviewer] = useState<Reviewer[] | null>(null);
    return (
        <ReviewerContext.Provider value={{ currentReviewer: currentReviewer, setCurrentReviewer }}>
            {children}
        </ReviewerContext.Provider>
    );
}

export function useReviewer() {
    const context = useContext(ReviewerContext);
    if (context === undefined) {
        throw new Error('useReviewer must be used within a ReviewerProvider');
    }
    return context;
}
